import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-tutorial',
    templateUrl: './tutorial.component.html',
    styleUrls: ['./tutorial.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TutorialComponent {

}
